import imageWithCaption from "../objects/imageWithCaption";
import { multilingualArrayBlockContent } from "../base";
import { defineType } from "sanity";
import publicAreaCategory from "./publicAreaCategory";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "shipFacility",
  title: "Ship Facility",
  type: "object",
  preview: {
    select: {
      title: "name",
      imageUrl: "images.0.asset.url"
    },
    prepare({ title, imageUrl }) {
      return {
        title: multilingualStringPreview(title),
        imageUrl
      };
    }
  },
  groups: [
    { name: "asCard", title: "Render as Card" },
    {
      name: "seo",
      title: "SEO, Routing & Tracking"
    }
  ],
  fields: [
    {
      name: "category",
      title: "Category",
      type: "reference",
      to: [{ type: publicAreaCategory.name }],
      validation: (Rule) => Rule.required()
    },
    {
      name: "name",
      title: "Name",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required(),
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "description",
      title: "Description",
      type: multilingualArrayBlockContent.name,
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "images",
      title: "Images",
      type: "array",
      of: [{ type: imageWithCaption.name }]
    },
    {
      name: "card",
      title: "Render as Card",
      type: "asCard",
      group: "asCard"
    }
  ]
});
